import {
  Component,
  Host,
  h,
  Prop,
} from "@stencil/core";

import { Layout } from "../../index";

/**
 * @slot - Slot for any content
 */
@Component({
  tag: "stzh-cell",
  styleUrl: "stzh-cell.scss",
  shadow: true
})
export class StzhCell {
  /** Default span of each cell */
  @Prop({ reflect: true }) span: number = 12;
  /** Default span of each cell above small breakpoint */
  @Prop({ reflect: true }) spanSmall: number;
  /** Default span of each cell above medium breakpoint */
  @Prop({ reflect: true }) spanMedium: number;
  /** Default span of each cell above large breakpoint */
  @Prop({ reflect: true }) spanLarge: number;
  /** Default span of each cell above ultra breakpoint */
  @Prop({ reflect: true }) spanUltra: number;

  /** Controlling how cell is aligned in main axis (sets margin: auto to left/right side) */
  @Prop({ reflect: true }) align: "none" | "left" | "right" | "middle" = "none";

  /** Control how cells items are positioned along a container's cross axis */
  @Prop({ reflect: true }) alignSelf: Layout.AlignSelf = "auto";

  render() {
    return (
      <Host>
        <div
          class={{
            "stzh-cell": true
          }}
        >
          <slot></slot>
        </div>
      </Host>
    );
  }
}
